import logger from "../../helpers/logger";

// storageService.js
const storage = () => {
  return sessionStorage;
};

export const getItem = (key) => {
  const data = storage().getItem(key);
  try {
    return data ? JSON.parse(data) : null;
  } catch (e) {
    logger.error(`Failed to parse item with key "${key}":`, e);
    return null;
  }
};

export const setItem = (key, value) => {
  try {
    storage().setItem(key, JSON.stringify(value));
  } catch (e) {
    logger.error(`Failed to save item with key "${key}":`, e);
  }
};

export const removeItem = (key) => {
  storage().removeItem(key);
};
